// sign-up.js

import { put, call, takeLatest } from "redux-saga/effects";

import { getCSRFTokenHeader } from "../../utils/auth";
import { getOptions } from "apm/helpers/fetch.js";

export const INITIAL_STATE = {
  isExistingUser: false,
  email: "",
  isFetching: false,
};

export const CHECK_EMAIL_DEBOUNCE_MS = 250;

// action types
const CHECK_EMAIL = "unido-web/sign-up/CHECK_EMAIL";
const CHECK_EMAIL_SUCCESS = "unido-web/sign-up/CHECK_EMAIL_SUCCESS";
const CHECK_EMAIL_FAILURE = "unido-web/sign-up/CHECK_EMAIL_FAILURE";
const RESET = "unido-web/sign-up/RESET";

// reducer
const signUpReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHECK_EMAIL:
      return {
        ...state,
        email: action.email,
        isFetching: true,
      };
    case CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        isExistingUser: true,
        isFetching: false,
      };
    case CHECK_EMAIL_FAILURE:
      return {
        ...state,
        isExistingUser: false,
        email: "",
        isFetching: false,
      };
    case RESET:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default signUpReducer;

// action creators
export const checkEmail = email => {
  return {
    type: CHECK_EMAIL,
    email,
  };
};

export const checkEmailSuccess = () => {
  return {
    type: CHECK_EMAIL_SUCCESS,
  };
};

export const checkEmailFailure = ex => {
  return {
    type: CHECK_EMAIL_FAILURE,
    ex,
  };
};

export const resetState = () => {
  return {
    type: RESET,
  };
};

// get request
const get = (url, headers) => {
  return fetch(url, getOptions(headers)).then(response => {
    if (!response.ok) {
      throw "User email does not exist";
    } else {
      return true;
    }
  });
};

// saga
export function* signUpWatcher() {
  yield takeLatest(CHECK_EMAIL, signUpWorker);
}

export function* signUpWorker(action) {
  try {
    const headers = {
      "X-CSRF-Token": getCSRFTokenHeader(),
    };
    const url = `/users/${action.email}`;
    yield call(get, url, headers);
    yield put(checkEmailSuccess());
  } catch (err) {
    yield put(checkEmailFailure(err));
  }
}

// selectors
export const isEmailAddressInUse = (state, props) =>
  state.signUp.isExistingUser;
